import type { ComponentPublicInstance, VNode, VNodeNormalizedChildren } from 'vue'
import type { Dayjs } from 'dayjs'

const opt = Object.prototype.toString

export const isArray = (obj: any): obj is any[] => {
  return opt.call(obj) === '[object Array]'
}

export const isNull = (obj: any): obj is null => {
  return opt.call(obj) === '[object Null]'
}

export const isBoolean = (obj: unknown): obj is boolean => {
  return opt.call(obj) === '[object Boolean]'
}

export const isObject = (obj: any): obj is Record<string, unknown> => {
  return opt.call(obj) === '[object Object]'
}

export const isPromise = <T>(obj: unknown): obj is Promise<T> => {
  return opt.call(obj) === '[object Promise]'
}

export const isString = (obj: any): obj is string => {
  return opt.call(obj) === '[object String]'
}

export const isNumber = (obj: any): obj is number => {
  return opt.call(obj) === '[object Number]' && obj === obj // eslint-disable-line
}

export const isRegExp = (obj: any) => {
  return opt.call(obj) === '[object RegExp]'
}

export const isDate = (obj: any) => {
  return opt.call(obj) === '[object Date]'
}

const isHex = (color: any) => {
  return /^#[a-fA-F0-9]{3}$|#[a-fA-F0-9]{6}$/.test(color)
}

const isRgb = (color: any) => {
  return /^rgb\((\s*\d+\s*,?){3}\)$/.test(color)
}

const isRgba = (color: any) => {
  return /^rgba\((\s*\d+\s*,\s*){3}\s*\d(\.\d+)?\s*\)$/.test(color)
}

export const isColor = (color: any): boolean => {
  return isHex(color) || isRgb(color) || isRgba(color)
}

export const isUndefined = (obj: any): obj is undefined => {
  return obj === undefined
}

export const isFunction = (obj: any): obj is (...args: any[]) => any => {
  return typeof obj === 'function'
}

export const isEmptyObject = (obj: any): boolean => {
  return isObject(obj) && Object.keys(obj).length === 0
}

export const isExist = (obj: any): boolean => {
  return obj || obj === 0
}

export const isWindow = (el: any): el is Window => {
  return el === window
}

export const isComponentInstance = (value: any): value is ComponentPublicInstance => {
  return value?.$ !== undefined
}

export const isArrayChildren = (children: VNodeNormalizedChildren): children is VNode[] => {
  return isArray(children)
}

export const isQuarter = (fromat: string) => {
  return /\[Q]Q/.test(fromat)
}

export const isDayjs = (time: any): time is Dayjs => {
  return (
    isObject(time) &&
    '$y' in time &&
    '$M' in time &&
    '$D' in time &&
    '$d' in time &&
    '$H' in time &&
    '$m' in time &&
    '$s' in time
  )
}
